import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const isHome = location.pathname === '/';

  const handleAnchorClick = (e, anchor) => {
    if (isHome) {
      e.preventDefault();
      const el = document.getElementById(anchor);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''} ${menuOpen ? 'navbar-menu-open' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={() => setMenuOpen(false)}>
          <img src="/images/logo-jaune.png" alt="THE RECAP Logo" />
        </Link>

        <button
          className={`navbar-hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`navbar-menu ${menuOpen ? 'navbar-menu-active' : ''}`}>
          <li className="navbar-item">
            <Link
              to="/"
              className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              Accueil
            </Link>
          </li>
          <li className="navbar-item">
            <Link
              to="/inscription"
              className={`navbar-link ${location.pathname === '/inscription' ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              Inscription
            </Link>
          </li>
          <li className="navbar-item">
            <Link
              to="/evenement"
              className={`navbar-link ${location.pathname === '/evenement' ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              Événements
            </Link>
          </li>
          <li className="navbar-item">
            {isHome ? (
              <a
                href="#qui-sommes-nous"
                className="navbar-link"
                onClick={(e) => handleAnchorClick(e, 'qui-sommes-nous')}
              >
                Qui sommes-nous ?
              </a>
            ) : (
              <Link
                to="/#qui-sommes-nous"
                className="navbar-link"
                onClick={() => setMenuOpen(false)}
              >
                Qui sommes-nous ?
              </Link>
            )}
          </li>
          <li className="navbar-item">
            <Link
              to="/nous-contacter"
              className={`navbar-link ${location.pathname === '/nous-contacter' ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </Link>
          </li>
          <li className="navbar-item navbar-item-members">
            <Link
              to="/members"
              className={`navbar-link navbar-link-members ${location.pathname.startsWith('/members') ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              Espace Membres
            </Link>
          </li>
        </ul>
      </div>

      {menuOpen && <div className="navbar-overlay" onClick={() => setMenuOpen(false)} />}
    </nav>
  );
};

export default Navbar;
